<template>
  <tr v-if="$route.query.style_list === 'table'">
    <td class="f18 fw500">
      {{ item.name }}
    </td>
    <td>
      <div class="employees">
        <template v-if="item.employees.length">
          <template v-for="(employee, index) in item.employees">
            <EmployeesTooltip :employee="employee" :key="index" :status="true" />
          </template>
        </template>
        <template v-else> - </template>
      </div>
    </td>

    <td>
      <div class="buttons">
        <ButtonShow toName="employeesGroupSelect" :toParams="item.id" />
        <DeleteModal
          v-if="
            $userCheckAccess({
              abilities: 'edit_hr',
            })
          "
          type="employeeGroup"
          :item="item"
          :text="
            localStorage.translations.pages.personnel_department['employees-group_dialog_delete'][
              'udalit-podrazdelenie'
            ] +
            ' ' +
            item.name
          "
        />
      </div>
    </td>
  </tr>
  <div v-else class="card">
    <h6 class="f18 fw500">
      {{ item.name }}
    </h6>
    <div class="employees" v-if="item.employees.length">
      <template v-for="(employee, index) in item.employees">
        <EmployeesTooltip :employee="employee" :key="index" :status="true" />
      </template>
    </div>
    <div class="buttons">
      <ButtonShow toName="employeesGroupSelect" :toParams="item.id" />
      <DeleteModal
        v-if="
          $userCheckAccess({
            abilities: 'edit_hr',
          })
        "
        type="employeeGroup"
        :item="item"
        :text="
          localStorage.translations.pages.personnel_department['employees-group_dialog_delete'][
            'udalit-podrazdelenie'
          ] +
          ' ' +
          item.name
        "
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import EmployeesTooltip from 'components/employees/EmployeesTooltip'
import DeleteModal from 'components/DeleteModal'
import ButtonShow from 'components/ButtonShow'

export default {
  name: 'EmployeesGroupListItem',
  components: {
    DeleteModal,
    ButtonShow,
    EmployeesTooltip,
  },
  props: ['item'],
  computed: {
    ...mapGetters('workTypeCategory', ['workTypeCategoryGridAll']),
    ...mapGetters('workClientProjectsWorkType', ['workClientProjectsWorkTypeAll_project']),
  },
}
</script>

<style lang="scss" scoped>
.card {
  background: #f2f2f2;
  border: 1px solid #d1d1d1;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  padding: 30px 30px 0;
  align-content: center;
  align-items: center;
  height: max-content;
  .buttons {
    margin-top: 15px;
    width: 100%;
    display: grid;
    grid-template-columns: repeat(auto-fit, 50px);
    grid-template-rows: 50px;
    grid-column-gap: 5px;
    justify-content: center;
  }
  .employees {
    margin-top: 20px;
    justify-content: center;
  }
}
.fullSize {
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
}
.employees {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  width: 100%;

  align-items: center;
}
</style>
